import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let productResearchConfigMountPromise = null;

export function initProductResearchConfigViewFragment({ onMounted } = {}) {
  registerViewMount('admin-product-research-config', () => mountProductResearchConfigView(onMounted));
}

async function mountProductResearchConfigView(onMounted) {
  if (document.getElementById('view-admin-product-research-config')) return;
  if (productResearchConfigMountPromise) return productResearchConfigMountPromise;

  productResearchConfigMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');

    await appendTrustedAdminViewFragment(host, '/admin-views/product-research-config.html', 'Unable to load product research config view');
    onMounted?.();
  })();

  try {
    await productResearchConfigMountPromise;
  } catch (error) {
    productResearchConfigMountPromise = null;
    throw error;
  }
}
